module.exports = __webpack_public_path__ + "img/drawing.8f7fec2.webp";